/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar16 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar16", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 18.302734 14.306641 C 19.723734 14.306641 20.841344 15.137219 21.027344 16.324219 L 19.275391 16.324219 C 19.163391 15.938219 18.777828 15.689453 18.298828 15.689453 C 17.429828 15.689453 16.877406 16.586625 16.941406 17.890625 L 17.033203 17.890625 C 17.345203 17.231625 17.980875 16.865234 18.796875 16.865234 C 20.129875 16.865234 21.115234 17.857312 21.115234 19.195312 C 21.114234 20.679312 19.948828 21.728516 18.298828 21.728516 C 17.297828 21.728516 16.47675 21.328938 15.96875 20.585938 C 15.49475 19.960938 15.246094 19.081875 15.246094 18.046875 C 15.246094 15.736875 16.412734 14.306641 18.302734 14.306641 z M 10.65625 14.496094 L 12.449219 14.496094 L 12.449219 21.542969 L 10.65625 21.542969 L 10.65625 16.113281 L 10.564453 16.113281 L 8.8652344 17.259766 L 8.8652344 15.716797 L 10.65625 14.496094 z M 18.283203 18.150391 C 17.653203 18.150391 17.175781 18.623281 17.175781 19.238281 C 17.175781 19.863281 17.658203 20.351562 18.283203 20.351562 C 18.908203 20.351562 19.396484 19.869047 19.396484 19.248047 C 19.396484 18.624047 18.918203 18.150391 18.283203 18.150391 z" />
      </svg>
    );
  }
}

IconCalendar16.defaultProps = {
  className: null
};

IconCalendar16.propTypes = {
  className: PropTypes.string
};

export default IconCalendar16;
